export const content = {
  da: {
    brandName: "Rejuvenate",
    nav: {
      home: "Forside",
      treatments: "Behandlinger",
      priceList: "Prisliste",
      gallery: "Før/Efter",
      privateDoctor: "Privatlæge",
      academy: "Akademi",
      about: "Om os",
      contact: "Kontakt",
      book: "Book tid"
    },
    hero: {
      title: "Skab dit smukkeste jeg med professionel ekspertise",
      subtitle: "Vi forener lægefaglig præcision med æstetisk sans for at give dig naturlige og smukke resultater.",
      cta: "Book din konsultation nu",
      secondaryCta: "Se behandlinger"
    },
    stats: [
      { label: "Behandlinger udført", value: "5.000+" },
      { label: "Glade kunder", value: "98%" },
      { label: "Års erfaring", value: "10+" }
    ],
    treatments: {
      title: "Vores Behandlinger",
      subtitle: "Skræddersyede løsninger til dine unikke behov",
      items: [
        {
          id: "botox",
          title: "Botox",
          description: "Effektiv reduktion af rynker og fine linjer for et mere udhvilet look.",
          longDescription: "Botox er en af de mest populære kosmetiske behandlinger på verdensplan. Det er en sikker og effektiv metode to at reducere rynker og fine linjer, hvilket giver ansigtet et mere udhvilet og ungdommeligt udtryk. Behandlingen virker ved midlertidigt at afslappe de muskler, der forårsager rynker, såsom bekymringsrynker mellem brynene, panderynker og smilerynker ved øjnene.",
          benefits: ["Reducerer synlige rynker", "Forebygger nye linjer", "Naturligt og friskt udseende", "Ingen restitutionstid"],
          process: "Behandlingen tager ca. 15-20 minutter. Vi anvender en meget tynd nål to at injicere små mængder Botox præcist i de valgte muskler. Effekten indtræder gradvist over 3-10 dage.",
          image: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/c982cea4-c0f6-40a2-9142-1f7a8d061c96.mp4"
        },
        {
          id: "filler",
          title: "Filler",
          description: "Genskab volumen og definer dine ansigtstræk naturligt.",
          longDescription: "Ikke-permanente fillere baseret på hyaluronsyre bruges to at genskabe tabt volumen, udglatte dybere rynker og markere ansigtets konturer. Hyaluronsyre findes naturligt i huden og binder fugt, hvilket giver et naturligt og blødt resultat. Vi bruger kun de mest anerkendte mærker for at sikre din sikkerhed og de bedste resultater.",
          benefits: ["Genskaber ansigtsvolumen", "Markering af læber og kindben", "Øjeblikkelige resultater", "Langvarig effekt"],
          process: "Vi starter med en grundig analyse af dit ansigt. Derefter injiceres filleren under huden med en fin nål eller kanyle. Resultatet ses med det samme, selvom der kan forekomme lidt hævelse i de første dage.",
          image: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/56f95339-38ae-4c20-8319-46666d730caf.jpeg"
        },
        {
          id: "laser",
          title: "Laserhårfjerning",
          description: "Permanent reduktion af uønsket hårvækst med den nyeste teknologi.",
          longDescription: "Slip for barbering, voksning og indgroede hår. Med vores avancerede laserteknologi kan vi tilbyde permanent hårreduktion på både krop og ansigt. Laseren målretter pigmentet i hårsækkene og ødelægger dem uden at skade den omkringliggende hud. Det er en effektiv og sikker vej til silkeblød hud året rundt.",
          benefits: ["Permanent hårreduktion", "Smertefri behandling", "Velegnet til alle hudtyper", "Ingen flere indgroede hår"],
          process: "Inden behandlingen barberes området. Under behandlingen føres laseren over huden, mens et kølesystem beskytter huden og øger komforten. Der kræves typisk 6-10 behandlinger for et optimalt resultat.",
          image: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/f2441588-d39a-4b67-9e01-f38643ee923f.mp4"
        },
        {
          id: "skinbooster",
          title: "Skinbooster",
          description: "Dybdegående fugt og forbedret hudkvalitet med øjeblikkelig glød.",
          longDescription: "Skinbooster er en fugtgivende behandling, der arbejder indefra. Ved at injicere tyndtflydende hyaluronsyre direkte i huden, forbedres elasticiteten, hudstrukturen og gløden markant. Det er den ultimative behandling til træt, tør eller solskadet hud, der trænger til en genoplivning uden at ændre på ansigtets form.",
          benefits: ["Intensiv fugt indefra", "Forbedret hudstruktur", "Øget spændstighed", "Fantastisk glød"],
          process: "Behandlingen udføres med mange små stik i huden. Det kan føles som små prik, men er hurtigt overstået. Vi anbefaler ofte et kurforløb på 3 behandlinger for at opnå det bedste og mest holdbare resultat.",
          image: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/a4db6300-6d36-48f1-9bb0-71d36296075c.jpeg"
        },
        {
          id: "microneedling",
          title: "Microneedling",
          description: "Stimulerer hudens egen kollagenproduktion for en fastere hud.",
          longDescription: "Microneedling skaber tusindvis af mikroskopiske kanaler i hudens overflade. Denne kontrollerede skade på huden igangsætter en naturlig helingsproces, hvor produktionen af kollagen og elastin boostes. Resultatet er en fastere, glattere og mere ensartet hud med færre ar og grove porer.",
          benefits: ["Minimerer porer og ar", "Opstrammer huden", "Jævner hudtonen", "Naturlig hudfornyelse"],
          process: "Vi bruger en avanceret pen med fine nåle. Inden behandlingen kan vi påføre en bedøvende creme. Efter behandlingen vil huden være rød som en solskoldning i 1-2 dage, mens den fornyer sig.",
          image: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/dc913704-4d84-4c62-a511-16bc1e14a507.mp4"
        }
      ]
    },
    reviews: {
      title: "Hvad vores kunder siger",
      items: [
        { name: "Sarah M.", text: "Gazelle er utrolig professionel, rolig og dygtig. Hun lytter til ens ønsker og guider en igennem hele forløbet, så man føler sig 100% tryg. Resultatet af min botox-behandling blev så fint og naturligt!", rating: 5 },
        { name: "Camilla S.", text: "Den bedste klinik i København! Gazelle tager sig rigtig god tid til forundersøgelsen og forklarer alt grundigt. Jeg fik lavet filler i læberne, og det er blevet præcis som jeg drømte om – meget naturligt og smukt.", rating: 5 },
        { name: "Julie K.", text: "Super professionel og tryg oplevelse hos Gazelle. Klinikken er utrolig flot og ren, og man føler sig velkommen med det samme. Kan varmt anbefale Rejuvenate til alle, der ønsker professionel behandling.", rating: 5 },
        { name: "Amalie T.", text: "Jeg har fået lavet laserhårfjerning hos Rejuvenate, og det er det bedste jeg har gjort for mig selv. Allerede efter få behandlinger er der markant forskel. Gazelle er så sød og professionel.", rating: 5 }
      ]
    },
    gallery: {
      title: "Resultater",
      subtitle: "Se forskellen med vores behandlinger",
      items: [
        { title: "Læbefiller", before: "Før", after: "Efter", image: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/b12d2fd5-3cda-42e9-ba23-f521b19691d2.jpg" },
        { title: "Botox Panden", before: "Før", after: "Efter", image: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/a10d402c-43ae-42c4-98df-acadf60c25d4.jpg" }
      ]
    },
    footer: {
      address: "Næsbyvej 6 st. 2610 Rødovre",
      phone: "+4552407752",
      email: "rejuvenate_copenhagen@hotmail.com",
      hours: [
        { day: "Mandag", hours: "Efter aftale" },
        { day: "Tirsdag", hours: "Efter aftale" },
        { day: "Onsdag", hours: "Efter aftale" },
        { day: "Torsdag", hours: "Efter aftale" },
        { day: "Fredag", hours: "Efter aftale" },
        { day: "Lørdag", hours: "Efter aftale" },
        { day: "Søndag", hours: "Efter aftale" }
      ],
      bookingNote: "Book online eller kontakt Rejuvenate på instagram eller facebook for en tid."
    }
  },
  en: {
    brandName: "Rejuvenate",
    nav: {
      home: "Home",
      treatments: "Treatments",
      priceList: "Price List",
      gallery: "Before/After",
      privateDoctor: "Private Doctor",
      academy: "Academy",
      about: "About Us",
      contact: "Contact",
      book: "Book Now"
    },
    hero: {
      title: "Reveal your most beautiful self with expert care",
      subtitle: "We combine medical precision with an aesthetic touch to provide natural and beautiful results.",
      cta: "Book your consultation now",
      secondaryCta: "View treatments"
    },
    stats: [
      { label: "Treatments performed", value: "5,000+" },
      { label: "Happy clients", value: "98%" },
      { label: "Years of experience", value: "10+" }
    ],
    treatments: {
      title: "Our Treatments",
      subtitle: "Tailored solutions for your unique needs",
      items: [
        {
          id: "botox",
          title: "Botox",
          description: "Effective reduction of wrinkles and fine lines for a more refreshed look.",
          longDescription: "Botox is one of the most popular cosmetic treatments worldwide. It is a safe and effective method to reduce wrinkles and fine lines, giving the face a more rested and youthful expression. The treatment works by temporarily relaxing the muscles that cause wrinkles, such as frown lines between the brows, forehead wrinkles, and crow's feet around the eyes.",
          benefits: ["Reduces visible wrinkles", "Prevents new lines", "Natural and fresh appearance", "No downtime"],
          process: "The treatment takes approx. 15-20 minutes. We use a very thin needle to inject small amounts of Botox precisely into the chosen muscles. The effect occurs gradually over 3-10 days.",
          image: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/c982cea4-c0f6-40a2-9142-1f7a8d061c96.mp4"
        },
        {
          id: "filler",
          title: "Filler",
          description: "Restore volume and define your facial features naturally.",
          longDescription: "Non-permanent fillers based on hyaluronic acid are used to restore lost volume, smooth out deeper wrinkles, and mark the contours of the face. Hyaluronic acid is naturally found in the skin and binds moisture, providing a natural and soft result. We only use the most recognized brands to ensure your safety and the best results.",
          benefits: ["Restores facial volume", "Definition of lips and cheekbones", "Immediate results", "Long-lasting effect"],
          process: "We start with a thorough analysis of your face. Then the filler is injected under the skin with a fine needle or cannula. The result is seen immediately, although some swelling may occur in the first few days.",
          image: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/56f95339-38ae-4c20-8319-46666d730caf.jpeg"
        },
        {
          id: "laser",
          title: "Laser Hair Removal",
          description: "Permanent reduction of unwanted hair growth with the latest technology.",
          longDescription: "Say goodbye to shaving, waxing, and ingrown hairs. With our advanced laser technology, we can offer permanent hair reduction on both body and face. The laser targets the pigment in the hair follicles and destroys them without damaging the surrounding skin. It is an effective and safe way to silky smooth skin all year round.",
          benefits: ["Permanent hair reduction", "Painless treatment", "Suitable for all skin types", "No more ingrown hairs"],
          process: "Before the treatment, the area is shaved. During the treatment, the laser is guided over the skin while a cooling system protects the skin and increases comfort. Typically 6-10 treatments are required for an optimal result.",
          image: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/f2441588-d39a-4b67-9e01-f38643ee923f.mp4"
        },
        {
          id: "skinbooster",
          title: "Skinbooster",
          description: "Deep hydration and improved skin quality with instant glow.",
          longDescription: "Skinbooster is a moisturizing treatment that works from within. By injecting thin hyaluronic acid directly into the skin, elasticity, skin structure, and glow are significantly improved. It is the ultimate treatment for tired, dry, or sun-damaged skin that needs a revival without changing the shape of the face.",
          benefits: ["Intense moisture from within", "Improved skin structure", "Increased elasticity", "Amazing glow"],
          process: "The treatment is performed with many small punctures in the skin. It can feel like small pricks but is quickly over. We often recommend a course of 3 treatments to achieve the best and most durable result.",
          image: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/a4db6300-6d36-48f1-9bb0-71d36296075c.jpeg"
        },
        {
          id: "microneedling",
          title: "Microneedling",
          description: "Stimulates the skin's own collagen production for firmer skin.",
          longDescription: "Microneedling creates thousands of microscopic channels in the skin's surface. This controlled damage to the skin triggers a natural healing process where the production of collagen and elastin is boosted. The result is a firmer, smoother, and more uniform skin with fewer scars and large pores.",
          benefits: ["Minimizes pores and scars", "Tightens the skin", "Evens skin tone", "Natural skin renewal"],
          process: "We use an advanced pen with fine needles. Before the treatment, we can apply a numbing cream. After the treatment, the skin will be red like a sunburn for 1-2 days while it renews itself.",
          image: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/dc913704-4d84-4c62-a511-16bc1e14a507.mp4"
        }
      ]
    },
    reviews: {
      title: "What our clients say",
      items: [
        { name: "Sarah M.", text: "Gazelle is incredibly professional, calm, and skilled. She listens to your wishes and guides you through the entire process, making you feel 100% safe. The result of my Botox treatment was so beautiful and natural!", rating: 5 },
        { name: "Camilla S.", text: "The best clinic in Copenhagen! Gazelle takes her time during the consultation and explains everything thoroughly. I had lip fillers done, and they turned out exactly as I dreamed of – very natural and beautiful.", rating: 5 },
        { name: "Julie K.", text: "Super professional and safe experience with Gazelle. The clinic is incredibly beautiful and clean, and you feel welcome right away. Highly recommend Rejuvenate to anyone wanting professional treatment.", rating: 5 },
        { name: "Amalie T.", text: "I had laser hair removal at Rejuvenate, and it's the best thing I've done for myself. Already after a few treatments, there is a significant difference. Gazelle is so sweet and professional.", rating: 5 }
      ]
    },
    gallery: {
      title: "Results",
      subtitle: "See the difference with our treatments",
      items: [
        { title: "Lip Filler", before: "Before", after: "After", image: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/b12d2fd5-3cda-42e9-ba23-f521b19691d2.jpg" },
        { title: "Forehead Botox", before: "Before", after: "After", image: "https://assets.auxodev.dk/assets/9dae0889-d679-4ee4-8a71-4cd89c3be7b6/a10d402c-43ae-42c4-98df-acadf60c25d4.jpg" }
      ]
    },
    footer: {
      address: "Næsbyvej 6 st. 2610 Rødovre",
      phone: "+4552407752",
      email: "rejuvenate_copenhagen@hotmail.com",
      hours: [
        { day: "Monday", hours: "By appointment" },
        { day: "Tuesday", hours: "By appointment" },
        { day: "Wednesday", hours: "By appointment" },
        { day: "Thursday", hours: "By appointment" },
        { day: "Friday", hours: "By appointment" },
        { day: "Saturday", hours: "By appointment" },
        { day: "Sunday", hours: "By appointment" }
      ],
      bookingNote: "Book online or contact Rejuvenate on Instagram or Facebook for an appointment."
    }
  }
};
